<template>
  <div class="introduction ">
    <HeroSection :size="size" :theme="theme" class="text-white-70">
      <!-- Icon Blocks Section -->
      <div v-if="!hideTitle" class="text-center mb-6">
        <h1 class="font-size-4 text-warning">{{ title }}</h1>
        <h4 class="font-size-2 px-10 mt-3 text-white">Our MortgageWatch service never sleeps and is constantly talking to all UK lenders to find the latest mortgage deals for you</h4>
      </div>
      <div class="row text-center">
        <div class="col-xs-6 col-sm-6 col-md-3 mb-3 mb-sm-5">
          <!-- Icon Blocks -->
          <div class="text-center px-lg-3">
            <figure class="max-w-13rem mx-auto mb-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-white-9.svg" alt="SVG">
            </figure>
            <h4 class="text-white">Your goals</h4>
            <p class="font-size-1">Tell us about your remortgage goals and so we can monitor the market on your behalf.</p>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 mb-3 mb-sm-5">
          <!-- Icon Blocks -->
          <div class="text-center px-lg-3">
            <figure class="max-w-13rem mx-auto mb-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-white-11.svg" alt="SVG">
            </figure>
            <h4 class="text-white">Sit back &amp; relax</h4>
            <p class="font-size-1">As the end of your current deal draws closer, we'll search the market and alert you to the best deals.</p>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 mb-3 mb-sm-5">
          <!-- Icon Blocks -->
          <div class="text-center px-lg-3">
            <figure class="max-w-13rem mx-auto mb-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-white-42.svg" alt="SVG">
            </figure>
            <h4 class="text-white">Explore deals</h4>
            <p class="font-size-1">Compare the deals to find the right one for you - to help we'll highlight the best savings.</p>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 mb-3 mb-sm-5">
          <!-- Icon Blocks -->
          <div class="text-center px-lg-3">
            <figure class="max-w-13rem mx-auto mb-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-white-27.svg" alt="SVG">
            </figure>
            <h4 class="text-white">Remortgage &amp; save</h4>
            <p class="font-size-1">Found the deal you want? Apply online, via your favourite broker or direct with the Lender.</p>
          </div>
        </div>
      </div>
      <div v-if="customCta" class="text-center mt-4 mb-8">
        <button class="btn btn-soft-light" style="min-width: 50%" @click="$emit('clicked')">{{ customCtaText }}</button>
      </div>
      <div v-if="includeCta" class="text-center mt-4 mb-8">
        <router-link
            to="/mortgage-watch/getting-started"
            v-slot="{ href, route, navigate }">
          <button class="btn btn-light" style="min-width: 50%" :href="href" @click="navigate">Create a MortgageWatch Alert</button>
        </router-link>
      </div>
    </HeroSection>
  </div>
</template>

<script>
import HeroSection from "@/components/layout/HeroSection";
export default {
  name: "WelcomeToMortgageWatch",
  components: {HeroSection},
  
  props: {
    theme: {
      type: String,
      default: "home/welcome"
    },
    title: {
      type: String,
      default: "Create your FREE MortgageWatch Alert"
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    includeCta: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md"
    },
    customCta: {
      type: Boolean,
      default: false
    },
    customCtaText: {
      type: String,
      default: "Custom CTA (click me!)"
    }
  }
};
</script>
